import React from "react"
import { graphql, PageProps } from "gatsby"
import PageContent from "../components/PageContent"
import Header from "../components/header"
import Seo from "../components/seo"
import Layout from "../components/layout"
import "../styles/page.scss"

interface Frontmatter {
  listName?: string
  nameOfClass?: string
  popupGithubLink?: string
  popupImageAlt?: string
  popupImageSrc?: string
  popupLiveLink?: string
  techIcons?: string[]
  title: string
  video?: string
  description?: string
  keywords?: string
}

interface PageTemplateData {
  markdownRemark: {
    html: string
    excerpt: string
    frontmatter: Frontmatter
  }
}

const SEO_BASE_KEYWORDS = [
  "Ayemun Hossain",
  "Ayemun Hossain portfolio",
  "software engineer",
  "backend engineer",
  "AI engineer",
  "DevSecOps",
]

const Template: React.FC<PageProps<PageTemplateData>> = ({ data }) => {
  const { markdownRemark } = data
  const { frontmatter, html, excerpt } = markdownRemark

  const description =
    (frontmatter.description && frontmatter.description.trim()) ||
    (excerpt && excerpt.trim()) ||
    `${frontmatter.title} — a project by Ayemun Hossain.`

  const techList = frontmatter.techIcons || []
  const keywords =
    (frontmatter.keywords && frontmatter.keywords.trim()) ||
    Array.from(
      new Set([frontmatter.title, ...techList, ...SEO_BASE_KEYWORDS])
    )
      .filter(Boolean)
      .join(", ")

  return (
    <Layout>
      <Seo
        title={frontmatter.title}
        description={description}
        keywords={keywords}
        image={frontmatter.popupImageSrc}
        article
      />
      <Header />
      <PageContent
        title={frontmatter.title}
        video={frontmatter.video}
        popupImageSrc={frontmatter.popupImageSrc}
        popupImageAlt={frontmatter.popupImageAlt}
        popupGithubLink={frontmatter.popupGithubLink}
        popupLiveLink={frontmatter.popupLiveLink}
        techIcons={frontmatter.techIcons}
        html={html}
      />
    </Layout>
  )
}

export default Template

export const pageQuery = graphql`
  query ($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      excerpt(pruneLength: 180, format: PLAIN)
      frontmatter {
        listName
        nameOfClass
        popupGithubLink
        popupImageAlt
        popupImageSrc
        popupLiveLink
        techIcons
        title
        video
        description
        keywords
      }
    }
  }
`
